import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { GuaranteeSealModule } from '../../../components/guarantee-seal/guarantee-seal.module';
import { combineLatest, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { getOrderformSubmitState } from '../../../ngrx/orderform.selectors';

@Component({
  selector: 'orderform-buy-button',
  templateUrl: './buy-button.component.html',
  styleUrls: ['./buy-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [GuaranteeSealModule, NgIf, NgClass, LetDirective, AsyncPipe],
})
export class BuyButtonComponent {
  constructor(private store: Store) {}
  private _theme$ = new BehaviorSubject<string>('');
  @Input() set theme(t: string) {
    this._theme$.next(t);
  }

  private _iconLeft$ = new BehaviorSubject<string>('');
  @Input() set iconLeft(t: string) {
    this._iconLeft$.next(t);
  }

  private _iconRight$ = new BehaviorSubject<string>('');
  @Input() set iconRight(t: string) {
    this._iconRight$.next(t);
  }

  private _sealType$ = new BehaviorSubject<'gold' | 'blue' | null>(null);
  @Input() set sealType(t: 'gold' | 'blue' | null) {
    this._sealType$.next(t);
  }

  private _customText$ = new BehaviorSubject<string>('');
  @Input() set customText(t: string) {
    this._customText$.next(t);
  }

  private _text$ = new BehaviorSubject<string>('');
  @Input() set text(t: string) {
    this._text$.next(t);
  }

  private _translationModeActive$ = new BehaviorSubject<boolean>(false);
  @Input() set translationModeActive(mode: boolean) {
    this._translationModeActive$.next(mode);
  }

  private _disabled$ = new BehaviorSubject<boolean>(false);
  @Input() set disabled(t: boolean) {
    this._disabled$.next(t);
  }

  @Output() readonly submit = new EventEmitter<void>();

  public vm$ = combineLatest([
    this._theme$,
    this._iconLeft$,
    this._iconRight$,
    this._sealType$,
    this._customText$,
    this._translationModeActive$,
    this._text$,
    this._disabled$,
    this.store.select(getOrderformSubmitState),
  ]).pipe(
    map(([theme, iconLeft, iconRight, sealType, customText, translationModeActive, text, disabled, submitState]) => {
      return {
        theme,
        iconLeft,
        iconRight,
        sealType,
        customText,
        translationModeActive,
        text,
        disabled,
        isPending: submitState === 'pending',
      };
    })
  );
}
